export default "__VITE_ASSET__vNI04QRJ__"